import '../styles/contact.css';

const Contact = () => {
    return (
        <section id="contact" class="contact">
            <div class="section-header">
                <span class="subtitle">Contact</span>
                <h2>Let's Work Together</h2>
                <p class="section-desc">Have a project in mind? Let's talk about it.</p>
            </div>

            <div class="contact-container">
                <div class="contact-info">
                    <div class="contact-card">
                        <div class="contact-card-content">
                            <i class="fas fa-envelope"></i>
                            <h3>Email</h3>
                            <p>rtpushpak@gmail.com</p>
                            <a href="mailto:rtpushpak@gmail.com" class="contact-link">Send Email</a>
                        </div>
                    </div>

                    <div class="contact-card">
                        <div class="contact-card-content">
                            <i class="fas fa-map-marker-alt"></i>
                            <h3>Location</h3>
                            <p>Bangalore, India</p>
                        </div>
                    </div>

                    <div class="contact-card">
                        <div class="contact-card-content">
                            <i class="fab fa-linkedin"></i>
                            <h3>LinkedIn</h3>
                            <p>Let's connect professionally</p>
                            <a href="https://www.linkedin.com/in/pushpak-bhattacharya/" class="contact-link">Connect on LinkedIn</a>
                        </div>
                    </div>
                </div>

                <div class="contact-form-container">
                    <form id="contact-form" class="contact-form">
                        <div class="form-header">
                            <h3>Send Message</h3>
                            <p>I'll get back to you as soon as possible.</p>
                        </div>

                        <div class="form-group">
                            <div class="input-group">
                                <input type="text" id="name" required />
                                <label for="name">Your Name</label>
                                <i class="fas fa-user"></i>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="input-group">
                                <input type="email" id="email" required />
                                <label for="email">Your Email</label>
                                <i class="fas fa-envelope"></i>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="input-group">
                                <input type="text" id="subject" required />
                                <label for="subject">Subject</label>
                                <i class="fas fa-pencil-alt"></i>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="input-group">
                                <textarea id="message" required></textarea>
                                <label for="message">Your Message</label>
                                <i class="fas fa-comment-alt"></i>
                            </div>
                        </div>

                        <button type="submit" class="submit-btn">
                            <span>Send Message</span>
                            <i class="fas fa-paper-plane"></i>
                        </button>
                    </form>
                </div>
            </div>
        </section>
    )
}

export default Contact;